export default "__VITE_ASSET__B_MpG3qc__"